import type { StockMovement } from "@/lib/stock.api";

export const STOCK_PAGE_GUIDE = [
  "Consultez le stock disponible par article.",
  "Utilisez « Réapprovisionner » pour enregistrer une entrée ou une correction.",
];

export const STOCK_PAGE_TIP =
  "Le stock ne peut jamais devenir négatif ici, contrairement à l'émission d'un document où un manager+ peut passer outre.";

export const STOCK_TABS = {
  articles: "articles",
  movements: "movements",
} as const;

export const MOVEMENT_LABELS: Record<StockMovement["type"], string> = {
  IN: "Entrée",
  OUT: "Sortie",
  ADJUST: "Ajustement",
};

export const MOVEMENT_TONES: Record<StockMovement["type"], string> = {
  IN: "bg-success-bg text-success-text border-success-border",
  OUT: "bg-danger-bg text-danger-text border-danger-border",
  ADJUST: "bg-warning-bg text-warning-text border-warning-border",
};
